import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import {
  getSportIconAndHeading,
  serverFormatToDateString,
} from "../../../system";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { TableViewIcon } from "../../../assets/images/icon/iconsProvider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { RejectIcon, TickIcon } from "../../../assets/images/icon";
import {
  boatTypeEnumReversed,
  levelEnumReversed,
  proficiencyLevelEnumReversed,
  timezoneConstants,
  translationConstants,
} from "../../../constants";
import ViewCertificateAttachments from "../Modals/ViewCertificateAttachments";

const AdminCertificateView = ({
  certificates,
  approveRejectHandler,
  isInstructorView = false,
  isViewCertificatesOnly = true,
  ...props
}) => {
  const { t } = useTranslation();
  const [selectedQualifications, setSelectedQualifications] = useState([]);
  const [isViewAttachmentModal, setViewAttachmentModal] = useState(false);

  const handleViewAttachments = (qualifications) => {
    setSelectedQualifications(qualifications);
    setViewAttachmentModal(true);
  };

  return (
    <div className="certificate-accordion-modal">
      {certificates?.map((document, index) => {
        const { icon, heading } = getSportIconAndHeading(t, document?.sportId);

        return (
          <Accordion
            key={index}
            data-column-id="certificates"
            className="w-100"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expandIcon" />}
              aria-controls="panel1-content"
              id="panel1-header"
              className="accordion-summary"
            >
              {icon && <img src={icon} className="px-2" alt="sportIcon" />}
              {heading}
            </AccordionSummary>
            <AccordionDetails className="accordion-details">
              <section className="accordion-details-container">
                <Row className="accordion-detail-heading">
                  <Col xs={isViewCertificatesOnly ? 3 : 2}>
                    {t(translationConstants.BOAT_TYPE)}
                  </Col>
                  <Col xs={3}>{t(translationConstants.COMPLETION_DATE)}</Col>
                  <Col xs={3}>
                    {isViewCertificatesOnly
                      ? t(translationConstants.LEVEL)
                      : t(translationConstants.SUGGESTED_LEVEL)}
                  </Col>
                  <Col
                    xs={isViewCertificatesOnly ? 3 : 2}
                    className={isViewCertificatesOnly && "text-center"}
                  >
                    {t(translationConstants.ATTACHMENTS)}
                  </Col>
                  {!isViewCertificatesOnly && <Col xs={2}></Col>}
                </Row>
                {document.boatTypeLevels?.map((levelDetail, i) => (
                  <Row key={i} className="accordion-detail-content mt-1">
                    <Col
                      xs={isViewCertificatesOnly ? 3 : 2}
                      className="align-self-center"
                    >
                      {t(
                        translationConstants[
                          boatTypeEnumReversed[levelDetail.boatTypeId]
                        ]
                      )}
                    </Col>
                    <Col xs={3} className="align-self-center">
                      {serverFormatToDateString(
                        levelDetail.dateOfCompletionString,
                        timezoneConstants.dayMonthYearFormat
                      )}
                    </Col>
                    <Col xs={3} className="align-self-center">
                      {t(
                        translationConstants[
                          levelEnumReversed[levelDetail.levelId]
                        ]
                      )}
                      {levelDetail.proficiencyLevelId &&
                        ` - ${t(
                          translationConstants[
                            proficiencyLevelEnumReversed[
                              levelDetail.proficiencyLevelId
                            ]
                          ]
                        )}`}
                    </Col>
                    <Col
                      xs={isViewCertificatesOnly ? 3 : 2}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <TableViewIcon
                        onClick={() =>
                          handleViewAttachments(levelDetail.qualifications)
                        }
                      />
                    </Col>
                    {!isViewCertificatesOnly && (
                      <Col
                        xs={2}
                        className="d-flex justify-content-evenly align-items-center"
                      >
                        {["approved", "rejected"].map((action) => (
                          <img
                            key={action}
                            src={action === "approved" ? TickIcon : RejectIcon}
                            alt={`${action}Icon`}
                            name={action}
                            className="height-width-23 cursor-pointer"
                            onClick={(e) =>
                              approveRejectHandler?.(e, {
                                ...levelDetail,
                                sportId: document.sportId,
                              })
                            }
                          />
                        ))}
                      </Col>
                    )}
                  </Row>
                ))}
              </section>
            </AccordionDetails>
          </Accordion>
        );
      })}

      {isViewAttachmentModal && (
        <ViewCertificateAttachments
          isViewAttachmentModal={isViewAttachmentModal}
          setViewAttachmentModal={setViewAttachmentModal}
          qualifications={selectedQualifications}
        />
      )}
    </div>
  );
};

export default AdminCertificateView;
